import { Placeholder, PlaceholderLine, Segment } from '@mairistem/composants';
import React from 'react';

const LiquidationTreeviewLoader = () => (
	<Segment data-testid="liquidationTreeviewLoader">
		<Placeholder fluid>
			{Array.from({ length: 5 }).map((_, index) => (
				// biome-ignore lint/suspicious/noArrayIndexKey: array de taille 5
				<PlaceholderLine key={`loaderLine-${index}`} length="full" />
			))}
		</Placeholder>
	</Segment>
);

export default LiquidationTreeviewLoader;
